import axios from "@/plugins/axios";

let url = "/api/console/deposits";

/** @typedef {object} UserDeposit */

export const deposits = {
    /**
     * @param {import("axios").AxiosRequestConfig} data
     * @returns {Promise<{ summary: { totalCount: number }, deposits: UserDeposit[]}>}
     */
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },

    /**
     * @param {{ _id: string }} data
     * @returns {Promise<{ deposit: UserDeposit }>}
     */
    get(data) {
        return axios.get(`${url}/${data._id}`).then((result) => result.data);
    },

    /**
     * @param {Partial<UserDeposit>} data
     * @returns {Promise<{ deposit: UserDeposit }>}
     */
    post(data) {
        return axios.post(url, data).then((result) => result.data);
    },

    /**
     * @param {Partial<UserDeposit>} data
     * @returns {Promise<{ deposit: UserDeposit }>}
     */
    put(data) {
        return axios.put(`${url}/${data._id}`, data).then((result) => result.data);
    },

    /**
     * @param {{ _id: string }} data
     * @returns {Promise<{ deposit: UserDeposit }>}
     */
    delete(data) {
        return axios.delete(`${url}/${data._id}`).then((result) => result.data);
    },
};

export default deposits;
